import * as React from "react";
import "./filterWrapper.scss";
import Filter from "../../../../model/workspace/Filter";
import StringFilter from "../StringFilter";
import {ColumnTypeEnum} from "../../../../model/workspace/ColumnDefinition";
import LeadStatusFilter from "../LeadStatusFilter";
import UsersFilter from "../AssigneesFilter";
import IndividualContactFilter from "../IndividualContactFilter";
import BrandFilter from "../BrandFilter";
import DateFilter from "../dateFilter/DateFilter";
import PartnerBrandFilter from "../PartnerBrandFilter";
import NumberFilter from "../numberFilter/NumberFilter";
import EnumFilter from "../EnumFilter";
import {PaymentMethodFilter} from "../PaymentMethodFilter";
import {PaymentMethod} from "../../../../model/payment/Payment";
import {option} from "ts-option";
import {BankAccountType, ReconciliationStatus} from "../../../../model/transaction/Transaction";
import JobStatusFilter from "../JobStatusFilter";
import MerchantFilter from "../MerchantFilter";
import CustomFieldFilter from "../customField/CustomFieldFilter";
import {BillStatus} from "../../../../model/bill/Bill";
import {RootState} from "../../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import {fetchIndividualContacts} from "../../../../store/action/contacts/contacts";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import {connect} from "react-redux";
import LeadTagFilter from "../LeadTagFilter";
import {WorkspaceName} from "../../table/workspace/WorkspaceContainer";
import JobTagFilter from "../JobTagFilter";
import {BooleanStatusFilter} from "../BooleanStatusFilter";
import {BooleanFilter} from "../BooleanFilter";
import JobTypeFilter from "../JobTypeFilter";
import {JobInvoicePath, JobInvoicePathLabelEnum} from "../../../../model/job/JobInvoicePath";
import JobWarrantyRegistrationStatusFilter from "../JobWarrantyRegistrationStatusFilter";

interface IProps {
	filter: Filter;
	onRemove: (refreshData: boolean) => void;
	onChange: (filter: Filter) => void;
	workspaceName: WorkspaceName
}

interface IDispatchProps {
	fetchContacts: () => void;
}

interface ReduxProps {
	/**
	 * Indicates if all contacts are fetched
	 */
	allContactsFetched: boolean;
}

type Props = ReduxProps & IDispatchProps & IProps;

class FilterWrapper extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
	}

	componentDidMount() {
		if (!this.props.allContactsFetched && this.props.filter.columnDefinition.type === ColumnTypeEnum.Contact) {
			this.props.fetchContacts();
		}
	}

	render() {
		return (
			<div className={"c-filter-wrapper reset-dropdown-right"}>
				{this.getFilter()}
			</div>
		)
	}

	getFilter() {
		const props = {...this.props, isFilterConfigVisible: this.props.filter.values.isEmpty};
		let tagFilter: string | JSX.Element = "Not implemented yet";
		if (this.props.workspaceName === WorkspaceName.Leads) {
			tagFilter = <LeadTagFilter {...props}/>
		}
		else if (this.props.workspaceName === WorkspaceName.Jobs) {
			tagFilter = <JobTagFilter {...props}/>
		}
		switch (this.props.filter.columnDefinition.type) {
			case ColumnTypeEnum.String:
			case ColumnTypeEnum.Uuid:
				return <StringFilter {...props}/>;
			case ColumnTypeEnum.LeadAssignee:
			case ColumnTypeEnum.JobAssignee:
			case ColumnTypeEnum.Creator:
			case ColumnTypeEnum.User:
				return <UsersFilter {...props}/>;
			case ColumnTypeEnum.LeadStatus:
				return <LeadStatusFilter {...props}/>;
			case ColumnTypeEnum.JobStatus:
				return <JobStatusFilter {...props}/>;
			case ColumnTypeEnum.JobWarrantyRegistrationStatus:
				return <JobWarrantyRegistrationStatusFilter {...props}/>;
			case ColumnTypeEnum.Contact:
				return <IndividualContactFilter {...props}/>;
			case ColumnTypeEnum.JobType:
				return <JobTypeFilter {...props}/>;
			case ColumnTypeEnum.InvoicePath:
				return <EnumFilter {...props}
								   items={Object.keys(JobInvoicePath)}
								   itemToLabel={(item: JobInvoicePath) => JobInvoicePathLabelEnum[item]}/>;
			case ColumnTypeEnum.Date:
				return <DateFilter {...props}/>;
			case ColumnTypeEnum.Brand:
				return <BrandFilter {...props}/>;
			case ColumnTypeEnum.PartnerBrand:
				return <PartnerBrandFilter {...props}/>;
			case ColumnTypeEnum.LeadTag:
			case ColumnTypeEnum.JobTag:
				return tagFilter;
			case ColumnTypeEnum.Appointments:
				return <DateFilter {...props} isCollection/>;
			case ColumnTypeEnum.Currency:
			case ColumnTypeEnum.Decimal:
			case ColumnTypeEnum.Percentage:
			case ColumnTypeEnum.Long:
				return <NumberFilter {...props}/>;
			case ColumnTypeEnum.Reconciliation:
				return <EnumFilter {...props} items={Object.keys(ReconciliationStatus)}/>;
			case ColumnTypeEnum.PaymentMethod:
				return <PaymentMethodFilter {...props} items={option(Object.keys(PaymentMethod))}/>;
			case ColumnTypeEnum.Merchant:
				return <MerchantFilter {...props}/>;
			case ColumnTypeEnum.BankAccountType:
				return <EnumFilter {...props} items={Object.keys(BankAccountType)}/>;
			case ColumnTypeEnum.LeadCustomField:
			case ColumnTypeEnum.JobCustomField:
				return <CustomFieldFilter {...props}/>;
			case ColumnTypeEnum.BillStatus:
				return <EnumFilter {...props} items={Object.keys(BillStatus)}/>;
			case ColumnTypeEnum.StatusBoolean:
				return <BooleanStatusFilter {...props}/>;
			case ColumnTypeEnum.Boolean:
				return <BooleanFilter {...props}/>;
			default:
				return "Not implemented yet"
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		allContactsFetched: state.contact.allContactsFetched
	};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchContacts: () => dispatch(fetchIndividualContacts(() => {},
			(err) => {notifyBugsnagAndShowToast(err, 'Fetch contacts')}))
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterWrapper)
